import { createSelector } from "reselect"
import { get } from "lodash"
import { createQueryStringSelector } from "selectors/queryString"

const getRawIsBasicAuth = state => get(state, "modules.login.isBasicAuth")
const getRawSelectedEmail = state => get(state, "modules.login.selectedEmail")
const getCurrentUserEmail = state => get(state, "user.email")

export const getRequireMfa = state => get(state, "modules.login.requireMfa", false)
export const getRequireCaptcha = state => get(state, "modules.login.requireCaptcha", false)
export const getPasswordExpired = state => get(state, "modules.login.passwordExpired", false)
export const getErrorMessage = state => get(state, "modules.login.errorMessage")
export const getSsoProvider = state => get(state, "user.ssoProviderType")

export const getIsRefreshMode = (_, props) => get(props, "isRefreshMode")
export const getUserMfaEnabled = state => get(state, "user.mfaEnabled")

export const getServerRedirectUrl = createQueryStringSelector("serverRedirect")
const getRedirectPath = createQueryStringSelector("redirect")
const getRedirectSearch = createQueryStringSelector("redirectSearch")
export const getErrorCode = createQueryStringSelector("errorCode", "", { overrideParseOptions: { parseNumbers: false } })

export const getRedirectUrl = createSelector(
  [getRedirectPath, getRedirectSearch],
  (redirectPath, redirectSearch) => {
    if (!redirectPath) {
      return ""
    }

    return redirectPath + (redirectSearch ? `?${redirectSearch}` : "")
  },
)

export const getSelectedEmail = createSelector(
  [getRawSelectedEmail, getCurrentUserEmail],
  (moduleSelectedEmail, userEmail) => userEmail || moduleSelectedEmail,
)

export const getIsBasicAuth = createSelector(
  [getRawIsBasicAuth, getSsoProvider],
  (rawBasicAuth, userSsoProvider) => rawBasicAuth || !userSsoProvider,
)

export const getTitle = createSelector(
  [getIsRefreshMode],
  (isRefreshMode) => isRefreshMode ? "Session expired" : "Welcome back.",
)

export const getSubTitle = createSelector(
  [getIsRefreshMode, getRequireMfa, getPasswordExpired],
  (isRefreshMode, requireMfa, passwordExpired) => {
    if (passwordExpired) {
      return "Your password has expired, a link to reset your password has been emailed to you"
    }
    if (requireMfa) {
      return "Enter your two-factor app authentication code"
    }
    if (isRefreshMode) {
      return "Your session has expired, please sign in again to continue"
    }
    return "Login to your account here"
  })
